import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>Building the Future,<br />One Structure at a Time</h1>
        <p>
          Rajmaya Group is a trusted name in construction, delivering quality
          infrastructure and turning visions into reality.
        </p>
        <a href="#contact" className="btn">Get in Touch</a>
      </div>
    </section>
  );
};

export default Hero;
